import React from 'react'
import { useAppDispatch } from '@SonarCX/hooks/redux'

import Button from '@SonarCX/components/atoms/Button2'
import ButtonSecondary from '@SonarCX/components/atoms/ButtonSecondary'

import { checkValidEmail } from '@SonarCX/utilities/tsUtils'
import { AddSuccessAlert } from '@SonarCX/slices/alert'
import { useUserAPI } from '@SonarCX/providers/UserAPIProvider'
import useStyles from './styles'

type GrantAccessProps = {
  user: LocalUser
  canEdit: boolean
}

const GrantAccess: React.FC<GrantAccessProps> = ({ user, canEdit }) => {
  const dispatch = useAppDispatch()

  const { uploadUser } = useUserAPI()

  const [granting, setGranting] = React.useState(false)
  const [value, setValue] = React.useState('')

  const isValidEmail = React.useMemo(() => checkValidEmail(value), [value])

  const classes = useStyles()

  const handleStartGranting = React.useCallback(() => {
    setGranting(true)
  }, [])

  const handleCancel = React.useCallback(() => {
    setGranting(false)
    setValue('')
  }, [])

  const handleGrantAccess = React.useCallback(() => {
    const updated = {
      ...user,
      auth: {
        email: value,
        suspended_at: null
      }
    }

    uploadUser(updated, false, () => {
      dispatch(AddSuccessAlert('Changes saved'))
    })

    handleCancel()
  }, [value, uploadUser, user, dispatch, handleCancel])

  return (
    <>
      {granting && (
        <input
          autoFocus
          placeholder='Login email address'
          value={value}
          onChange={e => setValue(e.target.value)}
          className={classes.input}
        />
      )}

      <div className={classes.buttons}>
        {!granting ? (
          <Button
            onClick={handleStartGranting}
            disabled={!canEdit}
            className={classes.button}
          >
            Grant Access
          </Button>
        ) : (
          <>
            <Button onClick={handleCancel} className={classes.button}>
              Cancel
            </Button>

            <ButtonSecondary
              onClick={handleGrantAccess}
              disabled={!isValidEmail}
              className={classes.button}
            >
              Confirm
            </ButtonSecondary>
          </>
        )}
      </div>
    </>
  )
}

export default GrantAccess
